import moment from "moment";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/userContext";
import IOSPicker from "../Common/IOSPicker/IOSPicker";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import Navbar from "../Navbar/Navbar";
import { TableRow, TableRowRedemption } from "./TableRow";
import axiosInstance from "../../config/axiosInstance";
function History({ baseURL, clientID, currency }) {
    const { authUser } = useAuth();

    const [menu, setMenu] = useState("purchase");

    const [transactionHistory, setTransactionHistory] = useState({});

    const [reedeemedVouchers, setRedeemedVouchers] = useState([]);

    const [customerData, setCustomerData] = useState({});

    const [filterOptions, setFilterOptions] = useState([]);

    const [selectedName, setSelectedName] = useState("");

    const [filterBoxDisplay, setFilterBoxDisplay] = useState("height-0 opacity-0");

    const [loadingCustomer, setLoadingCustomer] = useState(false); // Loading state for customer data
    const [loadingFilter, setLoadingFilter] = useState(false); // Loading state for filtered data

    function switchMenu(menu) {
        setMenu(menu);
    }
    useEffect(() => {
        console.log(transactionHistory, "tran", reedeemedVouchers);
    }, [menu]);

    const today = moment();

    const defaultFilterOptions = [
        {
            name: "Last 3 days",
            value: today.clone().subtract(3, "day").format("YYYY-MM-DD"),
        },
        {
            name: "Last 7 days",
            value: today.clone().subtract(7, "day").format("YYYY-MM-DD"),
        },
        {
            name: "Last 30 days",
            value: today.clone().subtract(30, "day").format("YYYY-MM-DD"),
        },
        {
            name: "Last 60 days",
            value: today.clone().subtract(60, "day").format("YYYY-MM-DD"),
        },
        {
            name: "Last month",
            value: today.clone().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), // Start of the last month
        },
        {
            name: "Last 3 months",
            value: today.clone().subtract(3, "month").startOf("month").format("YYYY-MM-DD"),
        },
        {
            name: "Last 6 months",
            value: today.clone().subtract(6, "month").startOf("month").format("YYYY-MM-DD"),
        },
    ];

    const [selectedValue, setSelectedValue] = useState(defaultFilterOptions[0].value);

    useEffect(() => {
        if (authUser) {
            getCustomerData(baseURL);

            // Get the current year

            const currentYear = today.year();

            // Dynamically add year options

            for (let year = currentYear; year >= currentYear - 3; year--) {
                defaultFilterOptions.push({
                    name: year.toString(),

                    value: moment(`${year}-01-01`).format("YYYY-MM-DD"),
                });
            }

            setFilterOptions(defaultFilterOptions);
            setSelectedName(defaultFilterOptions[0].name);
            setSelectedValue(defaultFilterOptions[0].value);
        }
    }, [authUser]);

    const getCustomerData = async (baseURL) => {
        try {
            setLoadingCustomer(true); // Start loading
    
            const payLoad = {
                DIV_DES: "",
                DIV_ID: "1",
                FUNCTION: "GetLoyPoints",
                SEND_KEY: "123456",
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    TYPE_NAME: "CUSTOMER",
                    MOBILE_NUM: authUser?.MOBILE ?? "",
                    CUST_CODE: authUser?.CUST_CODE ?? "",
                    CLIENT_ID: clientID,
                },
            };
    
            const response = await axiosInstance.post(`${baseURL}/GetLoyPoints`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            // Check if the response status indicates success
            if (!response?.data?.STATUS) {
                console.error(`API Error: ${response?.data?.MESSAGE || "Unknown error"}`);
                throw new Error(response?.data?.MESSAGE || "Failed to fetch customer data.");
            }
    
            setCustomerData(response?.data); // Assuming response.data contains the customer data
        } catch (error) {
            console.error("Error in getCustomerData:", error?.message);
            setCustomerData({}); // Reset data in case of failure
        } finally {
            setLoadingCustomer(false); // End loading in all cases
        }
    };
    

    const getToDate = (selectedName) => {
        const today = moment(); // Current date
        switch (selectedName) {
            case "Last 3 days":
                return today.format("YYYY-MM-DD");
            case "Last 7 days":
                return today.format("YYYY-MM-DD");
            case "Last 30 days":
                return today.format("YYYY-MM-DD");
            case "Last 60 days":
                return today.format("YYYY-MM-DD");
            case "Last month":
                return today.clone().subtract(0, "month").endOf("month").format("YYYY-MM-DD");
            case "Last 3 months":
                return today.clone().subtract(0, "month").endOf("month").format("YYYY-MM-DD");
            case "Last 6 months":
                return today.clone().subtract(0, "month").endOf("month").format("YYYY-MM-DD");

            // Handle year-based filters
            case "2021":
            case "2022":
            case "2023":
                return moment(`${selectedName}-12-31`).format("YYYY-MM-DD"); // End of the selected year

            default:
                return today.format("YYYY-MM-DD"); // Default to today for other cases
        }
    };

    const filterDate = async () => {
        setLoadingFilter(true); // Start loading
        const payLoad = {
            DIV_DES: "",
            DIV_ID: "1",
            FUNCTION: "GetLoyPoints",
            SEND_KEY: "123456",
            DATA: {
                AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                TYPE_NAME: "CUSTOMER_HISTORY",
                MOBILE_NUM: authUser?.MOBILE ?? "", // Using optional chaining and nullish coalescing
                FROM_DATE: selectedValue,
                TO_DATE: getToDate(selectedName), // Dynamically set TO_DATE
                CLIENT_ID: clientID,
            },
        };
    
        try {
            const response = await axiosInstance.post(`${baseURL}/GetLoyPoints`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            setLoadingFilter(false); // End loading
    
            if (response?.data?.STATUS) {
                const compositeURL = response?.data?.BILL_DETAILS ?? [];
                const itemDetails = response?.data?.ITEM_DETAILS ?? [];
                const vouchersIssued = response?.data?.VOUCHER_ISSUED ?? [];
                const vouchersRedeemed = [...response?.data?.VOUCHER_REDEEMED ?? []];
                const pointsEarned = response?.data?.POINTS_EARNED ?? [];
    
                compositeURL.forEach((billDetail) => {
                    billDetail.ITEM_DETAILS = itemDetails.filter(item => item?.BILLREF === billDetail.BILLREF);
                    billDetail.VOUCHER_ISSUED = vouchersIssued.filter(voucher => voucher?.BILLREF === billDetail.BILLREF);
                    billDetail.VOUCHER_REDEEMED = vouchersRedeemed.filter(voucher => voucher?.BILLREF === billDetail.BILLREF);
                    billDetail.POINTS_EARNED = pointsEarned.filter(point => point?.BILLREF === billDetail.BILLREF);
                });
    
                setTransactionHistory(compositeURL);
                setRedeemedVouchers(response?.data?.VOUCHER_REDEEMED ?? []);
            }
        } catch (error) {
            console.error("Error during filterDate API call:", error);
            setTransactionHistory([]); // Reset transaction history on error
            setRedeemedVouchers([]);   // Reset redeemed vouchers on error
        } finally {
            setLoadingFilter(false); // End loading in all cases
        }
    };
    

    function openFilter() {
        setFilterBoxDisplay("height-225 opacity-100");
    }

    function closeFilter() {
        setFilterBoxDisplay("height-0 opacity-0");
        setTimeout(() => {
            if (selectedName && selectedValue) {
                filterDate();
            }
            // Delay filterDate to avoid state dependencies triggering too quickly
        }, 300); // Adjust delay as needed to ensure state has been updated
    }

    const handleSelect = (option) => {
        setSelectedName(option);
    };

    const handleSelectCode = (option) => {
        setSelectedValue(defaultFilterOptions[0].value);
        setSelectedValue(option);
    };

    useEffect(() => {
        setSelectedValue(defaultFilterOptions[0].value);
        filterDate();
    }, [authUser]);

    return (
        <AnimatedPage>
            <div className="position-sticky z-2">
                <PageTitle name="TRANSACTION HISTORY" />
            </div>

            <div className="w-100 h-85 overflow-y-scroll pb-5 transition-0-5-bounce bg-wafaa-white-3">
                <div className="w-90 mx-auto py-2">
                    <div className="d-flex justify-content-end">
                        <div className="d-flex justify-content-between border-1 col-5 text-center text-blue-white font-size-11 border p-2 rounded-1 bg-wafaa-white-2" onClick={() => openFilter()}>
                            <span className="d-inline-block">{selectedName}</span>
                            <span className="d-inline-block" style={{ transform: `rotate(90deg)` }}>
                                &#10095;
                            </span>
                        </div>
                    </div>
                </div>

                <div className="btn-group w-90 d-flex mx-auto my-2" data-toggle="buttons" role="group" aria-label="Basic radio toggle button group">
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" defaultChecked />
                    <label
                        className="btn btn-wafaa-secondary text-wafaa-grey-2 font-size-16"
                        htmlFor="btnradio1"
                        onClick={() => {
                            switchMenu("purchase");
                        }}
                    >
                        My Purchase
                    </label>

                    <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" />
                    <label
                        className="btn btn-wafaa-secondary text-wafaa-grey-2 font-size-16"
                        htmlFor="btnradio2"
                        onClick={() => {
                            switchMenu("redemption");
                        }}
                    >
                        My Redemption
                    </label>
                </div>
                <div className="w-90 mx-auto pb-5 ">
                    <div className="row px-2 bg-table-head-history" style={{ marginInline: ".01rem" }}>
                        <div className="text-center font-weight-500 text-wafaa-history font-size-15 py-2 col-4 overflow-hidden transition-0-5-ease ps-1 pe-0">Date</div>
                        <div className={"text-center font-weight-500 text-wafaa-history font-size-15 py-2 col-4 overflow-hidden transition-0-5-ease px-0 "}>Amount</div>
                        <div className={"text-center font-weight-500 text-wafaa-history font-size-15 py-2 col-4 overflow-hidden transition-0-5-ease px-0 "}>Points</div>
                    </div>
                    {/* <div className="row px-3 border-bottom border-0 border-wafaa-grey-opacity-20  rounded-top">
            <div className="text-center font-weight-bold text-wafaa-dark-blue-2 dark:text-wafaa-light-grey font-size-15 py-3 col-4">
              Date
            </div>
            <div className="text-center font-weight-bold text-wafaa-dark-blue-2 dark:text-wafaa-light-grey font-size-15 py-3 col-4">
              Amount
            </div>
            <div className="text-center font-weight-bold text-wafaa-dark-blue-2 dark:text-wafaa-light-grey font-size-15 py-3 col-4">
              Points
            </div>
          </div> */}

                    <table className="bg-table-body-history w-100 table-borderless pb-5 table-fixed" style={{ marginBottom: "2.5rem" }}>
                        <tbody className="bg-table-body-history" style={{ paddingInline: "1rem" }}>
                            {loadingCustomer || loadingFilter ? (
                                <tr>
                                    <td colSpan="100" className="bg-transparent px-0 text-center py-2">
                                        {Array(5)
                                            .fill(0)
                                            .map((_, idx) => (
                                                <div key={idx} className="skeleton-loader"></div>
                                            ))}
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {menu === "purchase" &&
                                        (transactionHistory?.length > 0 ? (
                                            transactionHistory?.map((transaction) => <TableRow currency={currency} key={`purchase-${transaction?.BILLREF}`} transaction={transaction} />)
                                        ) : (
                                            <tr>
                                                <td colSpan="100" className="bg-wafaa-white-3 px-0 text-center text-wafaa-black-1 py-3">
                                                    No transactions
                                                </td>
                                            </tr>
                                        ))}
                                    {menu === "redemption" &&
                                        (reedeemedVouchers.length > 0 ? (
                                            reedeemedVouchers.map((transaction) => <TableRowRedemption currency={currency} key={`redemption-${transaction?.BILLREF}`} transaction={transaction} />)
                                        ) : (
                                            <tr>
                                                <td colSpan="100" className="bg-wafaa-white-3 px-0 text-center text-wafaa-black-1 py-3">
                                                    No redemptions
                                                </td>
                                            </tr>
                                        ))}
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="bg-wafaa-purple-2 text-white  w-100 position-fixed max-width-700 " style={{ bottom: "70px", padding: ".7em" }}>
                <div className="row m-0 font-size-12">
                    <div className="col-4">
                        <p className="mb-0 font-weight-400">Points balance</p>
                        <p className="mb-0 font-weight-700">{loadingCustomer ? "..." : customerData?.REDEEMABLEPOINTS ? customerData?.REDEEMABLEPOINTS : "00"} pts</p>
                    </div>

                    <div className="col-4">
                        <p className="mb-0 font-weight-400">Points value</p>
                        <p className="mb-0 font-weight-700">
                            {loadingCustomer ? "..." : customerData?.POINTS_VALUE ? customerData?.POINTS_VALUE : "0"} {currency || "AED"}
                        </p>
                    </div>

                    <div className="col-4">
                        <p className="mb-0 font-weight-400">Expired Points</p>
                        <p className="mb-0 font-weight-700">{loadingCustomer ? "..." : customerData?.POINTS_EXPIRED ? customerData?.POINTS_EXPIRED : "0"}</p>
                    </div>
                </div>
            </div>

            <IOSPicker
                // defaultSelection={false}
                options={filterOptions}
                selectedName={selectedName ? selectedName : filterOptions[0]?.name}
                selectedValue={selectedValue ? selectedValue : filterOptions[0]?.value}
                onSelect={(option) => handleSelect(option)}
                onSelectCode={(option) => handleSelectCode(option)}
                openModal={filterBoxDisplay === "height-225 opacity-100"}
                title={"Date"}
                handleClose={closeFilter}
                keyName={"name"}
                keyCode={"value"}
            />
            <Navbar activePage="history" />
        </AnimatedPage>
    );
}

export default History;
